import * as React from 'react';
const CheckEmpty = (props) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} fill='none' {...props}>
		<path stroke='#1f1f43b3' strokeWidth={2} d='M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z' />
	</svg>
);
export default CheckEmpty;
